module.exports = __webpack_public_path__ + "img/Åland Islands.9ee4d2f9.svg";